import { Button } from '@chakra-ui/react'
import { NextSeo } from 'next-seo'
import Head from 'next/head'
import NextLink from 'next/link'

export const Page = () => {
  return (
    <>
      <Head>
        <link href='/css/tailwindLegacy.css' rel='stylesheet' />
      </Head>
      <NextSeo title='International Quarantine Car Show 2020' />
      <div className='bg-black text-white'>
        <div
          className='bg-top bg-fixed'
          style={{
            backgroundSize: ' 1440px auto',
            backgroundImage:
              'url(/img/car-show/iqcs-boss-large-cropped@2x.png)',
          }}>
          <div
            className=''
            style={{
              backgroundSize: '1200px auto',
              backgroundPosition: 'center, -25% 25%',
              backgroundImage:
                'linear-gradient(rgba(0,0,0,.3),rgba(0,0,0,.5)), url(/img/car-show/car-show-grunge.png)',
            }}>
            <div className='max-w-xl mb-12 py-20 xl:pt-32 mx-auto'>
              <div
                className='relative overflow-hidden'
                style={{ paddingBottom: '84.5047923%' }}>
                <img
                  className='absolute pin w-full'
                  src='/img/car-show/iqcs-header-2@2x.png'
                  alt='Int’l Quarantine Car Show 2020'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='flex justify-center mt-4'>
          <Button as='a' href='#finalists' colorScheme='red' size='lg'>
            See the finalists
          </Button>
        </div>

        <div className='py-10 text-center'>
          <div className='bg-black pt-v2'>
            <div className='mx-auto max-w-3xl px-4'>
              <div
                className='relative overflow-auto bg-white'
                style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className='absolute top-0 right-0 bottom-0 left-0 h-full w-full'
                  src='https://www.youtube-nocookie.com/embed/Cr6wDxaueuc'
                  frameBorder='0'
                  allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                  allowFullScreen></iframe>
              </div>
            </div>
          </div>
        </div>

        <div
          className='bg-right-bottom bg-black text-white bg-no-repeat'
          style={{
            backgroundSize: '773px auto',
            backgroundImage:
              'url(/img/car-show/iqcs-finalboss-large-cropped@2x.png)',
          }}>
          <div className='container mx-auto px-4 py-12 lg:py-20'>
            <h2 className='text-center text-display2 font-bold leading-tight uppercase text-white mb-8'>
              The Judges
            </h2>
            <ul className='flex flex-wrap justify-between -mx-4'>
              <li className='w-1/2 md:w-1/3 lg:w-1/6 px-4 mb-8'>
                <div
                  className='relative overflow-hidden bg-white mb-3'
                  style={{ paddingBottom: '166.1111111%' }}>
                  <img
                    className='absolute top-0 bottom-0 right-0 left-0 ls-is-cached '
                    alt='Photo of '
                    src='https://debossgarage.s3.amazonaws.com/car-show/judges/iqcs-zipties.png'
                  />
                </div>
                <h3 className='text-xl leading-tight'>F*%!n Mint</h3>
                <a
                  className='hover:text-red'
                  href='https://www.youtube.com/user/RedliningRedneck'
                  target='_blank'
                  rel='noreferrer'>
                  Zip Ties N Bias Plies
                </a>
              </li>
              <li className='w-1/2 md:w-1/3 lg:w-1/6 px-4 mb-8'>
                <div
                  className='relative overflow-hidden bg-white mb-3'
                  style={{ paddingBottom: '166.1111111%' }}>
                  <img
                    className='absolute top-0 bottom-0 right-0 left-0 ls-is-cached '
                    alt='Photo of '
                    src='https://debossgarage.s3.amazonaws.com/car-show/judges/iqcs-vicegripgarage-1586346076.png'
                  />
                </div>
                <h3 className='text-xl leading-tight'>Most Factree</h3>
                <a
                  className='hover:text-red'
                  href='https://www.youtube.com/user/jaymz03ss'
                  target='_blank'
                  rel='noreferrer'>
                  Vice Grip Garage
                </a>
              </li>
              <li className='w-1/2 md:w-1/3 lg:w-1/6 px-4 mb-8'>
                <div
                  className='relative overflow-hidden bg-white mb-3'
                  style={{ paddingBottom: '166.1111111%' }}>
                  <img
                    className='absolute top-0 bottom-0 right-0 left-0 ls-is-cached '
                    alt='Photo of '
                    src='https://debossgarage.s3.amazonaws.com/car-show/judges/iqcs-rcr-1586346091.png'
                  />
                </div>
                <h3 className='text-xl leading-tight'>Purity</h3>
                <a
                  className='hover:text-red'
                  href='https://www.youtube.com/user/RegularCars'
                  target='_blank'
                  rel='noreferrer'>
                  Regular Car Reviews
                </a>
              </li>
              <li className='w-1/2 md:w-1/3 lg:w-1/6 px-4 mb-8'>
                <div
                  className='relative overflow-hidden bg-white mb-3'
                  style={{ paddingBottom: '166.1111111%' }}>
                  <img
                    className='absolute top-0 bottom-0 right-0 left-0 ls-is-cached'
                    alt='Photo of '
                    src='https://debossgarage.s3.amazonaws.com/car-show/judges/iqcs-sarahntuned-1586346623.png'
                  />
                </div>
                <h3 className='text-xl leading-tight'>Tuner Taste</h3>
                <a
                  className='hover:text-red'
                  href='https://www.youtube.com/channel/UCHSbIfwVuec_BwUrYAqN_qw'
                  target='_blank'
                  rel='noreferrer'>
                  Sarah -n- Tuned
                </a>
              </li>
              <li className='w-1/2 md:w-1/3 lg:w-1/6 px-4 mb-8'>
                <div
                  className='relative overflow-hidden bg-white mb-3'
                  style={{ paddingBottom: '166.1111111%' }}>
                  <img
                    className='absolute top-0 bottom-0 right-0 left-0 ls-is-cached '
                    alt='Photo of '
                    src='https://debossgarage.s3.amazonaws.com/car-show/judges/iqcs-skidfactory-1586345698.png'
                  />
                </div>
                <h3 className='text-xl leading-tight'>Enginuity</h3>
                <a
                  className='hover:text-red'
                  href='https://www.youtube.com/channel/UCFUBt5_cGJpt58XBIh4RtNA'
                  target='_blank'
                  rel='noreferrer'>
                  The Skid Factory
                </a>
              </li>
              <li className='w-1/2 md:w-1/3 lg:w-1/6 px-4 mb-8'>
                <div
                  className='relative overflow-hidden bg-white mb-3'
                  style={{ paddingBottom: '166.1111111%' }}>
                  <img
                    className='absolute top-0 bottom-0 right-0 left-0 ls-is-cached '
                    alt='Photo of '
                    src='https://debossgarage.s3.amazonaws.com/car-show/judges/iqcs-badobsession-1586346105.png'
                  />
                </div>
                <h3 className='text-xl leading-tight'>Bracketry</h3>
                <a
                  className='hover:text-red'
                  href='https://www.youtube.com/user/badobsessionmsport'
                  target='_blank'
                  rel='noreferrer'>
                  Bad Obsession Motorsport
                </a>
              </li>
            </ul>
          </div>

          <div className='max-w-2xl mx-auto px-4 py-12 lg:py-20'>
            <h2 className='text-center text-display2 font-bold leading-tight uppercase text-white mb-8'>
              The Awards
            </h2>
            <ul className='flex flex-wrap justify-between -mx-4'>
              <li className='w-1/2 w-1/3 px-4 mb-8 pt-24'>
                <img src='img/car-show/iqcs-boss@2x.png' alt='Trophy' />
              </li>
              <li className='w-1/2 w-1/3 px-4 mb-8'>
                <img src='img/car-show/iqcs-finalboss@2x.png' alt='Trophy' />
              </li>
              <li className='w-1/2 w-1/3 px-4 mb-8 pt-24'>
                <img src='/img/car-show/iqcs-2nd-boss@2x.png' alt='Trophy' />
              </li>
            </ul>
          </div>
        </div>

        <div id='finalists' className='bg-black text-white py-12'>
          <h2 className='text-center text-display2 font-bold leading-tight uppercase text-white mb-8'>
            The Finalists
          </h2>

          <div className='max-w-4xl mx-auto'>
            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1985-toyota-ra65-celica?category=tuner-taste'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_finalboss.png'
                          alt='IQCS 2020 Boss award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Mega Boss
                    </small>
                    1985 Toyota ra65 celica ›
                  </div>
                </a>
              </NextLink>
            </div>
            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink href='/nation/projects/1587770313-1979-ford-mustang-50-hatchback'>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_second_boss.png'
                          alt='IQCS 2020 Boss award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Second Boss
                    </small>
                    1979 Ford Mustang 5.0 Hatchback ›
                  </div>
                </a>
              </NextLink>
            </div>
            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1587060967-1973-ford-f250-73-diesel-swap'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_boss.png'
                          alt='IQCS 2020 Boss award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Boss
                    </small>
                    1973 Ford F250 7.3 Diesel Swap ›
                  </div>
                </a>
              </NextLink>
            </div>

            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1587361273-1985-chevy-crew-cab-dually-24v-59-cummins-2wd-to-4wd-conversion?category=f-n-mint'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_f_n_mint.png'
                          alt='IQCS 2020 F_n_mint award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Category winner
                    </small>
                    1985 Chevy Crew Cab Dually&nbsp;›
                  </div>
                </a>
              </NextLink>

              <div className='max-w-4xl mx-auto text-center'>
                <div
                  className='mt-8'
                  style={{
                    backgroundImage:
                      'linear-gradient(#27281a, #27281a 50%, #fff 50%)',
                  }}>
                  <div className='mx-auto max-w-screen-xl'>
                    <div
                      className='relative bg-grey200'
                      style={{ paddingBottom: '56.25%' }}>
                      <iframe
                        className='absolute w-full h-full top-0 right-0 bottom-0 left-0'
                        src='https://www.youtube.com/embed/S5nzZXaVOgI'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1587417792-1968-chevrolet-c10?category=most-factree'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_factree.png'
                          alt='IQCS 2020 Factree award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Category winner
                    </small>
                    1968 Chevrolet C10&nbsp;›
                  </div>
                </a>
              </NextLink>

              <div className='max-w-4xl mx-auto text-center'>
                <div
                  className='mt-8'
                  style={{
                    backgroundImage:
                      'linear-gradient(#27281a, #27281a 50%, #fff 50%)',
                  }}>
                  <div className='mx-auto max-w-screen-xl'>
                    <div
                      className='relative bg-grey200'
                      style={{ paddingBottom: '56.25%' }}>
                      <iframe
                        className='absolute w-full h-full top-0 right-0 bottom-0 left-0'
                        src='https://www.youtube.com/embed/MWvvj7kG_as'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1985-toyota-ra65-celica?category=tuner-taste'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_tuner_taste.png'
                          alt='IQCS 2020 Tuner_taste award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Category winner
                    </small>
                    1985 Toyota ra65 celica&nbsp;›
                  </div>
                </a>
              </NextLink>

              <div className='max-w-4xl mx-auto text-center'>
                <div
                  className='mt-8'
                  style={{
                    backgroundImage:
                      'linear-gradient(#27281a, #27281a 50%, #fff 50%)',
                  }}>
                  <div className='mx-auto max-w-screen-xl'>
                    <div
                      className='relative bg-grey200'
                      style={{ paddingBottom: '56.25%' }}>
                      <iframe
                        className='absolute w-full h-full top-0 right-0 bottom-0 left-0'
                        src='https://www.youtube.com/embed/36pIxTNvFDA'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1587770313-1979-ford-mustang-50-hatchback?category=purity'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_purity.png'
                          alt='IQCS 2020 Purity award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Category winner
                    </small>
                    1979 Ford Mustang 5.0 Hatchback&nbsp;›
                  </div>
                </a>
              </NextLink>

              <div className='max-w-4xl mx-auto text-center'>
                <div
                  className='mt-8'
                  style={{
                    backgroundImage:
                      'linear-gradient(#27281a, #27281a 50%, #fff 50%)',
                  }}>
                  <div className='mx-auto max-w-screen-xl'>
                    <div
                      className='relative bg-grey200'
                      style={{ paddingBottom: '56.25%' }}>
                      <iframe
                        className='absolute w-full h-full top-0 right-0 bottom-0 left-0'
                        src='https://www.youtube.com/embed/36pIxTNvFDA'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/1587060967-1973-ford-f250-73-diesel-swap?category=enginuity'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_enginuity.png'
                          alt='IQCS 2020 Enginuity award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Category winner
                    </small>
                    1973 Ford F250 7.3 Diesel Swap&nbsp;›
                  </div>
                </a>
              </NextLink>

              <div className='max-w-4xl mx-auto text-center'>
                <div
                  className='mt-8'
                  style={{
                    backgroundImage:
                      'linear-gradient(#27281a, #27281a 50%, #fff 50%)',
                  }}>
                  <div className='mx-auto max-w-screen-xl'>
                    <div
                      className='relative bg-grey200'
                      style={{ paddingBottom: '56.25%' }}>
                      <iframe
                        className='absolute w-full h-full top-0 right-0 bottom-0 left-0'
                        src='https://www.youtube.com/embed/G-xZ5L5pVTg'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='pt-4 my-4 border-grey100 border-4 bg-grey800'>
              <NextLink
                href='/nation/projects/ford-f100-1953?category=bracketry'
                legacyBehavior>
                <a className='flex items-center justify-center text-left text-xl sm:text-xl md:text-xxl leading-none'>
                  <div className='w-1/2'>
                    <div className='mx-auto' style={{ maxWidth: '160px' }}>
                      <div
                        className='relative'
                        style={{ paddingBottom: '165.6804734%' }}>
                        <img
                          className='mr-4 max-w-full pin-t pin-r pin-b pin-l absolute'
                          src='/img/awards/iqcs_bracketry.png'
                          alt='IQCS 2020 Bracketry award'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='w-1/2 md:w-3/4 border-l-2 border-grey100 p-4 md:pl-12'>
                    <small className='block text-sm uppercase mb-2 opacity-25'>
                      Category winner
                    </small>
                    Ford F100 1953 Bracketry&nbsp;›
                  </div>
                </a>
              </NextLink>

              <div className='max-w-4xl mx-auto text-center'>
                <div
                  className='mt-8'
                  style={{
                    backgroundImage:
                      'linear-gradient(#27281a, #27281a 50%, #fff 50%)',
                  }}>
                  <div className='mx-auto max-w-screen-xl'>
                    <div
                      className='relative bg-grey200'
                      style={{ paddingBottom: '56.25%' }}>
                      <iframe
                        className='absolute w-full h-full top-0 right-0 bottom-0 left-0'
                        src='https://www.youtube.com/embed/gHL8WfTLgR4'
                        frameBorder='0'
                        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Page
